export default "__VITE_ASSET__BZm6lB$4__"